import { Link } from 'react-router-dom'
import '../styles/App.css'

function Terms() {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to="/" className="legal-back">Stream Terrarium</Link>
      </nav>

      <div className="legal-content">
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: April 9, 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By using the Stream Terrarium extension, overlay, or website ("Service"), you agree to these Terms of Service.
          If you do not agree, do not use the Service.
        </p>

        <h2>2. Description of Service</h2>
        <p>
          Stream Terrarium is a free interactive Twitch overlay that allows viewers to grow plants, adopt insects, and
          interact within a shared terrarium using chat commands. The Service includes an optional Twitch Extension panel
          that supports In-Extension Bits for unlocking cosmetic skins, visual effects, and persistent perks.
        </p>

        <h2>3. Eligibility</h2>
        <p>
          You must have a valid Twitch account to use this Service. By using the Service, you represent that you are at
          least 13 years of age (or the minimum age required in your jurisdiction) and are able to form a binding agreement.
        </p>

        <h2>4. User Accounts & Authentication</h2>
        <p>
          The Service uses Twitch OAuth for authentication. We only request permissions necessary for the overlay to function
          (chat read/write, subscription status, moderation status). We never access your stream key, email, or payment information directly.
        </p>

        <h2>5. Bits & Redemptions</h2>
        <p>
          The Terrarium extension panel supports Twitch Bits redemptions. All Bits transactions are processed by Twitch and
          are subject to Twitch's Terms of Service and refund policies. Bits proceeds are distributed 80% to the streamer and
          20% to the extension developer, as determined by Twitch's standard In-Extension Bits program.
        </p>
        <p>
          Cosmetic unlocks, effects, and perks are tied to your Twitch user ID and the broadcaster's channel. They are not
          transferable between channels or users. We reserve the right to modify pricing, add, or remove products at any time.
        </p>

        <h2>6. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful purpose</li>
          <li>Attempt to exploit, hack, or reverse-engineer the Service</li>
          <li>Send abusive, harmful, or offensive content through the terrarium chat commands</li>
          <li>Impersonate other users or manipulate the terrarium to disrupt other viewers' experience</li>
          <li>Use automated scripts or bots to abuse the Service's commands or Bits system</li>
        </ul>

        <h2>7. Content & Intellectual Property</h2>
        <p>
          All visual assets (CSS plant art, insect art, UI design) and code are the intellectual property of Stream Terrarium.
          Broadcasters retain ownership of their stream content. User-generated content (custom plant names, chat messages)
          remains the property of the user but is displayed publicly within the terrarium overlay.
        </p>

        <h2>8. Availability & Modifications</h2>
        <p>
          The Service is provided "as is" without warranty. We may modify, suspend, or discontinue any part of the Service
          at any time without notice. We are not liable for any loss of data, cosmetics, or perks resulting from service changes.
        </p>

        <h2>9. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Stream Terrarium and its developer shall not be liable for any indirect,
          incidental, special, or consequential damages arising from your use of the Service, including but not limited to
          loss of Bits, cosmetics, or streaming revenue.
        </p>

        <h2>10. Termination</h2>
        <p>
          We reserve the right to suspend or terminate access to the Service for any user who violates these Terms.
          You may stop using the Service at any time by removing the overlay from your stream and uninstalling the extension.
        </p>

        <h2>11. Changes to Terms</h2>
        <p>
          We may update these Terms at any time. Continued use of the Service after changes constitutes acceptance of the
          updated Terms. We encourage you to review this page periodically.
        </p>

        <h2>12. Contact</h2>
        <p>
          For questions about these Terms, contact us via the Stream Terrarium GitHub repository or through Twitch
          at <a href="https://twitch.tv/f00d4tehg0dz" target="_blank" rel="noopener noreferrer">twitch.tv/f00d4tehg0dz</a>.
        </p>
      </div>

      <style>{`
        .legal-page {
          min-height: 100vh;
          background: #050a0f;
          color: #e0e0e0;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }
        html, body, #root {
          overflow: visible !important;
          overflow-y: auto !important;
          height: auto !important;
          min-height: 100vh;
        }
        .legal-nav {
          padding: 16px 32px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .legal-back {
          color: #888;
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
        }
        .legal-back:hover { color: #fff; }
        .legal-content {
          max-width: 720px;
          margin: 0 auto;
          padding: 48px 24px 80px;
          line-height: 1.7;
        }
        .legal-content h1 {
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 8px;
          color: #fff;
        }
        .legal-updated {
          color: #666;
          font-size: 13px;
          margin-bottom: 32px;
        }
        .legal-content h2 {
          font-size: 18px;
          font-weight: 600;
          margin-top: 32px;
          margin-bottom: 12px;
          color: #efeff1;
        }
        .legal-content p {
          margin-bottom: 12px;
          color: #bbb;
          font-size: 14px;
        }
        .legal-content ul {
          margin: 8px 0 16px 20px;
          color: #bbb;
          font-size: 14px;
        }
        .legal-content li { margin-bottom: 6px; }
        .legal-content a { color: #9147ff; }
        .legal-content a:hover { text-decoration: underline; }
      `}</style>
    </div>
  )
}

export default Terms
